import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { nextTick, ref, watch, } from 'vue';
import SelectedRequestMapItem from '@/entity/SelectedRequestMapItem';
import { pStore } from '@/pinia';
import { storeToRefs } from 'pinia';
import TransformDaumToRequestMap from '@/entity/TransformDaumToRequestMap';
import { enumAreasDaumToBackend } from '@/constants/requestMap';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DaumMapAddressItem',
    setup(__props) {
        const pRequestMap = pStore.piniaRequestMap;
        const { formData, } = storeToRefs(pRequestMap);
        const daumPostcodeElm = ref(null);
        const postcodeInstance = ref(null);
        /**
         * 다음 주소 검색 컴포넌트 생성
         */
        const createPostcode = async () => {
            const { Postcode: PostcodeClass, } = window.daum;
            const { Geocoder: GeocoderClass, Status, } = window.kakao.maps.services;
            postcodeInstance.value = new PostcodeClass({
                width: '100%',
                height: '100%',
                oncomplete: async (data) => {
                    const geocoder = new GeocoderClass();
                    geocoder.addressSearch(data.address, (result, status) => {
                        const daumData = result[0];
                        if (Status.OK === status) {
                            const daumSiDo = daumData.address.region_1depth_name;
                            // 다음 1depth_name으로 바로고 지역 코드를 추출한다.
                            const brgAreaTypeCode = enumAreasDaumToBackend[daumSiDo];
                            // 바로고 지역 코드로 바로고 지역 이름을 추출한다.
                            const brgSiDo = pRequestMap.getterAreaListForObject[brgAreaTypeCode];
                            // 다음 1depth_name을 치환한다.
                            daumData.address.region_1depth_name = brgSiDo;
                            const requestMapData = (new TransformDaumToRequestMap(daumData)).make();
                            formData.value.areaTypeCode = brgAreaTypeCode;
                            formData.value.selectedAddress = new SelectedRequestMapItem(requestMapData);
                            pRequestMap.publishUpdateMapPosition();
                        }
                    });
                },
            });
            postcodeInstance.value.embed(daumPostcodeElm.value, {
                autoClose: false,
            });
        };
        /**
         * tab 변경시 (바로고, 다음)
         */
        watch(() => formData.value.addressSource, async (v) => {
            if (v === 'DAUM') {
                await nextTick();
                createPostcode();
            }
        }, {
            immediate: true,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: "daum-address-embed",
                    ref_key: "daumPostcodeElm",
                    ref: daumPostcodeElm
                }, null, 512 /* NEED_PATCH */)
            ]));
        };
    }
});
